import { defineMessages } from "react-intl";
import { INVOICE_LOCAL_PAGE_TYPE } from "../InvoiceLocal/types";

export const scope = "components.HistoryDetails.components.InvoiceLocal";

export const messages = defineMessages({
  [INVOICE_LOCAL_PAGE_TYPE.INVOICE]: {
    id: `${scope}.${INVOICE_LOCAL_PAGE_TYPE.INVOICE}`,
    defaultMessage: "Invoice",
  },
  [INVOICE_LOCAL_PAGE_TYPE.CREDIT_NOTE]: {
    id: `${scope}.${INVOICE_LOCAL_PAGE_TYPE.CREDIT_NOTE}`,
    defaultMessage: "Credit Note",
  },
});
